import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';
import { getClients } from '../../reducers/clients';
import { setRole, unsetRole, getAdmins } from '../../reducers/users';
import { getProfile } from '../../reducers/identity';
import Table from '../../components/table';
import messages from '../../text/messages';
import { RoleDefinitions } from '../../utilities/roles';
import { InviteUserButton } from './../../components/richButtons';

import './clients.css';

class ClientsPage extends React.Component {
    constructor(props) {
        super(props);

        this.renderContent = this.renderContent.bind(this);
        this.getColumns = this.getColumns.bind(this);
        this.toggleSettings = this.toggleSettings.bind(this);
        this.getNotificationStatus = this.getNotificationStatus.bind(this);
        this.reloadOnSuccess = this.reloadOnSuccess.bind(this);
    }

    getNotificationStatus(client) {
        const { role, roles, user, setRole, unsetRole, getProfile, getClients } = this.props;

        let reloadData = () => getProfile(() => getClients(role.id, 'current', undefined, true));

        let assignedRole = roles.find(r => client.id === r.id);
        if (assignedRole) {
            let removeRole = () => unsetRole(user.id, assignedRole.role, client.id, reloadData);
            return (
                <span className="client-notification">
                    <i className="active material-icons" onClick={removeRole}>
                        notifications_active
                    </i>
                </span>
            );
        }

        let addRole = () => setRole(user.id, RoleDefinitions.AdminHumanResources.type, client.id, reloadData);
        return (
            <span className="client-notification">
                <i className="inactive material-icons" onClick={addRole}>
                    notifications_none
                </i>
            </span>
        );
    }

    reloadOnSuccess() {
        const { role, getClients } = this.props;
        return getClients(role.id, 'current', undefined, true);
    }

    toggleSettings(client) {
        history.push(`/client/${client.id}`);
    }

    getColumns() {
        return [
            {
                label: <FormattedMessage {...messages.client} />,
                valueMap: d => (
                    <div className="full-height-cell ellipsis clickable" onClick={() => this.toggleSettings(d)}>
                        {d.name}
                    </div>
                ),
                size: 'col-md-3 col-sm-8 col-xs-10',
                bold: true,
                sort: (a, b) => a.name.localeCompare(b.name)
            },
            {
                label: <FormattedMessage {...messages.contact} />,
                valueMap: d =>
                    d.contact_user_ext ? (
                        <div className="row name-column clickable" onClick={() => this.toggleSettings(d)}>
                            <div className="col-xs-12 name-cell ellipsis">
                                {d.contact_user_ext.first_name} {d.contact_user_ext.last_name}
                            </div>
                            <div className="col-xs-12 email-cell ellipsis">{d.contact_user_ext.email}</div>
                        </div>
                    ) : (
                        <div className="full-height-cell clickable" onClick={() => this.toggleSettings(d)}>
                            <FormattedMessage {...messages.notProvided} />
                        </div>
                    ),
                size: 'col-md-3 hidden-sm hidden-xs'
            },
            {
                label: <FormattedMessage {...messages.title} />,
                valueMap: d =>
                    d.contact_user_ext && d.contact_user_ext.job_title ? (
                        <div className="row clickable" onClick={() => this.toggleSettings(d)}>
                            <div className="col-xs-12 full-height-cell ellipsis">{d.contact_user_ext.job_title}</div>
                        </div>
                    ) : (
                        <div className="full-height-cell clickable" onClick={() => this.toggleSettings(d)}>
                            <FormattedMessage {...messages.notProvided} />
                        </div>
                    ),
                size: 'col-md-3 hidden-sm hidden-xs'
            },
            {
                label: <FormattedMessage {...messages.status} />,
                valueMap: d => (
                    <div className="full-height-cell clickable" onClick={() => this.toggleSettings(d)}>
                        {d.status}
                    </div>
                ),
                size: 'col-md-3 col-sm-2 hidden-xs',
                sort: (a, b) => a.status.localeCompare(b.status)
            }
        ];
    }

    componentDidMount() {
        const { role, getClients, getAdmins } = this.props;
        getClients(role.id, 'current', undefined, true);
        getAdmins(role);
    }

    renderContent() {
        const { clients } = this.props;
        const filteredClients = (clients || []).filter(client => client.status !== 'inactive');

        return (
            <div className="col-xs-12 clients-content">
                <Table data={filteredClients} columns={this.getColumns()} defaultSortColumn={0} />
            </div>
        );
    }

    render() {
        const button = (
            <span className="button pull-right">
                <FormattedMessage {...messages.inviteClient} />
            </span>
        );

        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{ClientsPage.meta.label}</h4>
                    </div>
                </div>

                <div className="row">
                    <InviteUserButton roles={[RoleDefinitions.Client]} isNewClient={true} onSuccess={this.reloadOnSuccess} button={button} />
                    <div className="col-xs-12">{this.renderContent()}</div>
                </div>
            </div>
        );
    }
}

ClientsPage.meta = {
    label: <FormattedMessage id={'clients'} defaultMessage={'Clients'} />,
    icon: 'people',
    action: () => history.push('/clients'),
    locations: ['/clients']
};

const mapStateToProps = state => ({
    role: state.identity.role,
    roles: state.identity.roles,
    user: state.identity.profile,
    clients: state.clients.list,
    admins: state.users.admins
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getProfile: getProfile,
            getAdmins: getAdmins,
            getClients: getClients,
            setRole: setRole,
            unsetRole: unsetRole
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ClientsPage);



// WEBPACK FOOTER //
// ./src/pages/clients/index.jsx